export default {
    data: () => ({
        translations: {
            title: {
                el: "Αναλογία Offline-Online Points",
                en: "Offline-Online Points Relation",
                it: "Rapporto punti Offline-Online"
            },
            info: {
                el: "Παρακαλώ ορίστε την αντιστοιχία Offline-Online πόντων που θα δίνονται στον χρήστη (π.χ.: Αν επιλέξετε 30%, αν οι online πόντοι είναι 100, τότε οι offline πόντοι θα είναι 30).",
                en: `
                    Please specify the Offline-Online relation for points that will be given
                    to the user (eg: If you select 30%, if the online points are 100, then
                    the offline points will be 30).
                `,
                it: "Si prega di specificare i punti Offline-Online da dare all'utente (ad esempio: se si seleziona 30%, se i punti online sono 100, allora i punti offline saranno 30)."
            },
            relation: {
                el: "Αναλογία",
                en: "Relation:",
                it: "Ratio"
            }
        }
    })
};
